import React, { } from 'react'
import { connect } from 'react-redux'
import { Dialog } from '@headlessui/react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

import useToggle from '../../../../hooks/useToggle'

import AgencySelector from './Select'
import { facilityFilterAgency } from '../../../../actions/facilitiesActions'

const connected = connect(store => {
  return {
    agencyStore: store.agency,
    agencyFilter: store.facilities.filter.agency
  }
})

const FacilityFilter = ({ dispatch, open, onClose, agencyStore, agencyFilter }) => {
  const removeAgencyFilter = () => dispatch(facilityFilterAgency(null))

  return (
    <div className="">
      {agencyFilter && (
        <button
          type="button"
          className="self-end mb-1 mr-4 text-sm font-light p-2 bg-green-200 border border-green-400 text-green-600 rounded-md mt-2"
          onClick={removeAgencyFilter}
        >
          <FontAwesomeIcon icon={faTimes} className="mr-2" />
          {agencyFilter?.name}
        </button>
      )}

      <Dialog
        open={open}
        className="fixed inset-0 z-[51] overflow-y-auto"
        onClose={() => onClose()}
      >
        <div className="flex items-center justify-center min-h-screen">
          <Dialog.Overlay className="fixed inset-0 bg-black opacity-60" />

          <div className="inline-block w-full max-w-4xl my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-lg">
            <div className="flex bg-gray-200 px-4 py-3 sm:px-6 ">
              <Dialog.Title className="flex-grow self-center text-xl font-semibold text-gray-900">
                Select Agency to filter by
              </Dialog.Title>

              <div className="flex-initial self-center">
                <button
                  type="button"
                  className="bg-gray-700 text-white font-semibold p-1 rounded-md"
                  onClick={() => onClose()}
                >
                  <span className="hidden md:inline">Close</span>
                  <span className="inline md:hidden">Close</span>
                </button>
              </div>
            </div>
            <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
              <AgencySelector onSelect={() => onClose()} />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default connected(FacilityFilter)
